export enum MeetingKind {
    MsTeams,
    VirtualAppointment,
}
